module.exports = __webpack_public_path__ + "img/img1.e7f9bd20.png";